/**
 * @module app.bdc.list.loseOrderCtrl
 *
 */
define(['angular'], function(angular) {


    function SendElectronicSignatureCtrl($scope, $uibModalInstance, $sce, commonService, electronicSignatureService) {
        var self = {};

        self.vad = false;
        self.joinRac = false;
        self.bundle = null;
        self.cniRecto = null;
        self.cniVerso = null;
        self.iban = null;
        self.preview = null;
        self.isLiz = false;
        self.liz = null;
        self.kbis = null;
        self.domiciliation = null;

        self.switchLiz = function() {
            self.isLiz = !self.isLiz;
            self.liz = self.isLiz && self.liz.trim() !== '' ? self.liz : null;
        }

        self.send = function() {
            if(self.bundle){
                $uibModalInstance.close({
                    vad: self.vad,
                    joinRac: self.joinRac,
                    liz: self.liz,
                    documents: {
                        bundle: self.bundle,
                        cniRecto: self.cniRecto,
                        cniVerso: self.cniVerso,
                        iban: self.iban,
                        kbis: self.kbis,
                        domiciliation: self.domiciliation
                    }
                });
            }else {
                Notification.error('Vous devez ajouter la liasse complète.')
            }

        };

        self.viewer = function (data){
            self.preview = data.split('base64,')[1];
            const contentType = electronicSignatureService.getType(data);
            // console.log(data);
            let blob = null;
            blob = commonService.b64toBlob(self.preview, contentType);
            self.blobURL = $sce.trustAsResourceUrl(URL.createObjectURL(blob) +  '#toolbar=0&navpane=0');
        };

        self.cancel = function() {
            $uibModalInstance.dismiss('cancel');
        };

        return self;
    }

    SendElectronicSignatureCtrl.$inject = ['$scope', '$uibModalInstance', '$sce', 'commonService', 'electronicSignatureService'];

    angular
        .module('app.bdc.reports.sendElectronicSignatureCtrl', ['ui.bootstrap.modal'])
        .controller('SendElectronicSignatureCtrl', SendElectronicSignatureCtrl)
        .directive('fileread', [
            function() {
                return {
                    scope: {
                        fileread: '='
                    },
                    link: function(scope, element, attributes) {
                        element.bind('change', function(changeEvent) {
                            var reader = new FileReader();
                            reader.onload = function(loadEvent) {
                                scope.$apply(function() {
                                    scope.fileread = loadEvent.target.result;
                                });
                            };
                            reader.readAsDataURL(changeEvent.target.files[0]);
                        });
                    }
                };
            }
        ]);
});
